<div *ngIf="authModalService.modalType() !== null" 
     class="modal-backdrop fixed inset-0 z-[200] flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fade-in"
     (click)="closeOnBackdrop($event)">
  
  <div class="modal-content relative w-full max-w-md mx-4 bg-[#FDFBF7] rounded-sm shadow-2xl animate-scale-up max-h-[90vh] overflow-y-auto">
    
    <!-- Close Button -->
    <button (click)="closeModal()" 
            class="absolute top-4 right-4 z-10 p-2 text-[#7A6E69] hover:text-[#3A2A25] transition-colors rounded-full hover:bg-[#E5DDD5]/20">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>

    <!-- Logo -->
    <div class="pt-8 pb-4 px-8 text-center border-b border-[#E5E0D5]/30">
      <img src="FINAL.png" alt="Aarvya Logo" class="w-40 sm:w-48 h-auto mx-auto object-contain mb-2">
    </div>

    <!-- Sign In Flow (Includes Email and Phone) -->
    <div *ngIf="authModalService.modalType() === 'signin'" class="p-8 space-y-6">
      <div class="space-y-1 text-center">
        <h2 class="text-2xl font-serif text-[#3A2A25]">Welcome Back</h2>
        <p class="text-sm text-[#8B7355]">Sign in to continue your wellness journey</p>
      </div>

      <button type="button" (click)="loginWithGoogle()" [disabled]="isSubmitting"
              class="w-full px-4 py-2.5 border border-[#E5E0D5] bg-white text-[#1A2E22] font-serif text-sm rounded-sm flex items-center justify-center gap-2 hover:bg-[#FDFBF7] transition-colors">
        <svg class="w-5 h-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
        </svg>
        <span>Continue with Google</span>
      </button>

      <div class="flex items-center gap-3 text-xs text-[#8B7355] uppercase tracking-wider">
        <span class="flex-1 h-px bg-[#E5E0D5]"></span>
        <span>Or sign in with</span>
        <span class="flex-1 h-px bg-[#E5E0D5]"></span>
      </div>

      <!-- Auth Method Toggle -->
      <div class="flex p-1 bg-[#E5DDD5]/30 rounded-sm">
        <button (click)="switchToEmail()" 
                [class.bg-white]="authMethod === 'email'"
                [class.shadow-sm]="authMethod === 'email'"
                class="flex-1 py-1.5 text-xs font-serif transition-all rounded-sm">
          Email
        </button>
        <button (click)="switchToPhone()" 
                [class.bg-white]="authMethod === 'phone'"
                [class.shadow-sm]="authMethod === 'phone'"
                class="flex-1 py-1.5 text-xs font-serif transition-all rounded-sm">
          Phone
        </button>
      </div>

      <!-- Email Sign In Form -->
      <form *ngIf="authMethod === 'email'" [formGroup]="signinForm" (ngSubmit)="submitSignIn()" class="space-y-4">
        <div class="space-y-1">
          <label class="block text-xs font-serif text-[#3A4D3F] tracking-wide">Email</label>
          <input type="email" formControlName="email" placeholder="Enter your email"
                 class="w-full px-4 py-3 bg-white border border-[#E5DDD5] text-[#3A2A25] placeholder-[#7A6E69]/60 font-serif focus:outline-none focus:border-[#A46A3F] transition-colors rounded-sm"
                 [disabled]="isSubmitting">
        </div>

        <div class="space-y-1">
          <div class="flex items-center justify-between">
            <label class="block text-xs font-serif text-[#3A4D3F] tracking-wide">Password</label>
            <button type="button" (click)="switchToForgotPassword()" class="text-xs text-[#7A6E69] hover:text-[#3A2A25] transition-colors">Forgot?</button>
          </div>
          <div class="relative">
            <input [type]="showPassword ? 'text' : 'password'" formControlName="password" placeholder="Enter your password"
                   class="w-full px-4 py-3 bg-white border border-[#E5DDD5] text-[#3A2A25] placeholder-[#7A6E69]/60 font-serif focus:outline-none focus:border-[#A46A3F] transition-colors rounded-sm pr-10"
                   [disabled]="isSubmitting">
            <button type="button" (click)="showPassword = !showPassword"
                    class="absolute right-3 top-1/2 -translate-y-1/2 text-[#7A6E69] hover:text-[#3A2A25] focus:outline-none">
              <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
              </svg>
            </button>
          </div>
        </div>

        <button type="submit" [disabled]="signinForm.invalid || isSubmitting"
                class="w-full px-6 py-3 bg-[#A46A3F] text-white font-serif tracking-wide rounded-sm shadow-md hover:bg-[#8C5632] hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 uppercase text-sm flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed">
          <span *ngIf="!isSubmitting">Sign In</span>
          <span *ngIf="isSubmitting" class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
        </button>
      </form>

      <div *ngIf="authMethod === 'phone' && !showOtpInput" class="space-y-4 animate-fade-in">
        <form [formGroup]="phoneForm" (ngSubmit)="submitPhone()" class="space-y-4">
          <div class="space-y-1">
            <label class="block text-xs font-serif text-[#3A4D3F] tracking-wide">Phone Number</label>
            <div class="flex rounded-sm overflow-hidden border border-[#E5DDD5] [&:focus-within]:border-[#A46A3F] transition-colors">
              <span class="flex items-center px-3 bg-[#F7F5F2] text-[#3A2A25] text-sm font-serif border-r border-[#E5DDD5] whitespace-nowrap select-none">+91</span>
              <input type="tel" formControlName="phoneNumber" placeholder="10-digit number"
                     maxlength="10" inputmode="numeric"
                     class="flex-1 px-4 py-3 bg-white text-[#3A2A25] placeholder-[#7A6E69]/60 font-serif focus:outline-none"
                     [disabled]="isSubmitting">
            </div>
          </div>

          <button type="submit" [disabled]="phoneForm.invalid || isSubmitting"
                  class="w-full px-6 py-3 bg-[#A46A3F] text-white font-serif tracking-wide rounded-sm shadow-md hover:bg-[#8C5632] hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 uppercase text-sm flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed">
            <span *ngIf="!isSubmitting">Send OTP</span>
            <span *ngIf="isSubmitting" class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
          </button>
        </form>
      </div>

      <!-- OTP Verification Form -->
      <div *ngIf="authMethod === 'phone' && showOtpInput" class="space-y-4 animate-fade-in">
        <div class="text-center space-y-2">
          <p class="text-sm text-[#8B7355]">Enter the 6-digit code sent to your phone</p>
          <button (click)="showOtpInput = false" class="text-xs text-[#A46A3F] hover:underline">Change Number</button>
        </div>
        <form [formGroup]="otpForm" (ngSubmit)="submitOtp()" class="space-y-4">
          <div class="space-y-1">
            <label class="block text-xs font-serif text-[#3A4D3F] tracking-wide">OTP Code</label>
            <input type="text" formControlName="otp" placeholder="123456" maxlength="6"
                   class="w-full px-4 py-3 bg-white border border-[#E5DDD5] text-[#3A2A25] placeholder-[#7A6E69]/60 font-serif text-center text-xl tracking-[0.5em] focus:outline-none focus:border-[#A46A3F] transition-colors rounded-sm"
                   [disabled]="isSubmitting">
          </div>

          <button type="submit" [disabled]="otpForm.invalid || isSubmitting"
                  class="w-full px-6 py-3 bg-[#A46A3F] text-white font-serif tracking-wide rounded-sm shadow-md hover:bg-[#8C5632] hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 uppercase text-sm flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed">
            <span *ngIf="!isSubmitting">Verify & Continue</span>
            <span *ngIf="isSubmitting" class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
          </button>
        </form>
      </div>

      <div class="text-center text-sm text-[#8B7355]">
        <span>New to Aarvya? </span>
        <button type="button" (click)="switchToSignUp()" class="text-[#3A2A25] underline underline-offset-2 hover:text-[#A46A3F]">Create account</button>
      </div>
    </div>

    <!-- Sign Up Form (Email - legacy) -->
    <div *ngIf="authModalService.modalType() === 'signup'" class="p-8 space-y-6">
      <div class="space-y-1 text-center">
        <h2 class="text-2xl font-serif text-[#3A2A25]">Create Account</h2>
        <p class="text-sm text-[#8B7355]">Join the ritual and begin your journey</p>
      </div>

      <button type="button" (click)="loginWithGoogle()" [disabled]="isSubmitting"
              class="w-full px-4 py-2.5 border border-[#E5E0D5] bg-white text-[#1A2E22] font-serif text-sm rounded-sm flex items-center justify-center gap-2 hover:bg-[#FDFBF7] transition-colors">
        <svg class="w-5 h-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
        </svg>
        <span>Sign up with Google</span>
      </button>

      <div class="flex items-center gap-3 text-xs text-[#8B7355] uppercase tracking-wider">
        <span class="flex-1 h-px bg-[#E5E0D5]"></span>
        <span>Or continue with</span>
        <span class="flex-1 h-px bg-[#E5E0D5]"></span>
      </div>

      <!-- Auth Method Toggle -->
      <div class="flex p-1 bg-[#E5DDD5]/30 rounded-sm">
        <button (click)="switchToEmail()" 
                [class.bg-white]="authMethod === 'email'"
                [class.shadow-sm]="authMethod === 'email'"
                class="flex-1 py-1.5 text-xs font-serif transition-all rounded-sm">
          Email
        </button>
        <button (click)="switchToPhone()" 
                [class.bg-white]="authMethod === 'phone'"
                [class.shadow-sm]="authMethod === 'phone'"
                class="flex-1 py-1.5 text-xs font-serif transition-all rounded-sm">
          Phone
        </button>
      </div>
      <form *ngIf="authMethod === 'email'" [formGroup]="signupForm" (ngSubmit)="submitSignUp()" class="space-y-4">
        <div class="space-y-1">
          <label class="block text-xs font-serif text-[#3A4D3F] tracking-wide">Full Name</label>
          <input type="text" formControlName="name" placeholder="Enter your name"
                 class="w-full px-4 py-3 bg-white border border-[#E5DDD5] text-[#3A2A25] placeholder-[#7A6E69]/60 font-serif focus:outline-none focus:border-[#A46A3F] transition-colors rounded-sm"
                 [disabled]="isSubmitting">
        </div>

        <div class="space-y-1">
          <label class="block text-xs font-serif text-[#3A4D3F] tracking-wide">Email</label>
          <input type="email" formControlName="email" placeholder="Enter your email"
                 class="w-full px-4 py-3 bg-white border border-[#E5DDD5] text-[#3A2A25] placeholder-[#7A6E69]/60 font-serif focus:outline-none focus:border-[#A46A3F] transition-colors rounded-sm"
                 [disabled]="isSubmitting">
        </div>

        <div class="space-y-1">
          <label class="block text-xs font-serif text-[#3A4D3F] tracking-wide">Password</label>
          <div class="relative">
            <input [type]="showPassword ? 'text' : 'password'" formControlName="password" placeholder="Create a password"
                   class="w-full px-4 py-3 bg-white border border-[#E5E0D5] text-[#1A2E22] placeholder-[#8B7355]/60 font-serif focus:outline-none focus:border-[#C9A227] transition-colors rounded-sm pr-10"
                   [disabled]="isSubmitting">
            <button type="button" (click)="showPassword = !showPassword"
                    class="absolute right-3 top-1/2 -translate-y-1/2 text-[#8B7355] hover:text-[#2C4A3B] focus:outline-none">
              <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
              </svg>
            </button>
          </div>
        </div>

        <div class="space-y-1">
          <label class="block text-xs font-serif text-[#3A4D3F] tracking-wide">Confirm Password</label>
          <div class="relative">
            <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword" placeholder="Re-enter your password"
                   class="w-full px-4 py-3 bg-white border border-[#E5E0D5] text-[#1A2E22] placeholder-[#8B7355]/60 font-serif focus:outline-none focus:border-[#C9A227] transition-colors rounded-sm pr-10"
                   [disabled]="isSubmitting">
            <button type="button" (click)="showConfirmPassword = !showConfirmPassword"
                    class="absolute right-3 top-1/2 -translate-y-1/2 text-[#8B7355] hover:text-[#2C4A3B] focus:outline-none">
              <svg *ngIf="!showConfirmPassword" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <svg *ngIf="showConfirmPassword" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
              </svg>
            </button>
          </div>
          <div *ngIf="signupForm.errors?.['passwordsMismatch'] && signupForm.get('confirmPassword')?.touched" class="mt-1 text-xs text-red-500">
            Passwords do not match
          </div>
        </div>

        <button type="submit" [disabled]="signupForm.invalid || isSubmitting"
                class="w-full px-6 py-3 bg-[#A46A3F] text-white font-serif tracking-wide rounded-sm shadow-md hover:bg-[#8C5632] hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 uppercase text-sm flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed">
          <span *ngIf="!isSubmitting">Create Account</span>
          <span *ngIf="isSubmitting" class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
        </button>
      </form>

      <!-- Phone Form (Sign Up) -->
      <div *ngIf="authMethod === 'phone' && !showOtpInput" class="space-y-4 animate-fade-in">
        <form [formGroup]="phoneForm" (ngSubmit)="submitPhone()" class="space-y-4">
          <div class="space-y-1">
            <label class="block text-xs font-serif text-[#3A4D3F] tracking-wide">Phone Number</label>
            <div class="flex rounded-sm overflow-hidden border border-[#E5DDD5] [&:focus-within]:border-[#A46A3F] transition-colors">
              <span class="flex items-center px-3 bg-[#F7F5F2] text-[#3A2A25] text-sm font-serif border-r border-[#E5DDD5] whitespace-nowrap select-none">+91</span>
              <input type="tel" formControlName="phoneNumber" placeholder="10-digit number"
                     maxlength="10" inputmode="numeric"
                     class="flex-1 px-4 py-3 bg-white text-[#3A2A25] placeholder-[#7A6E69]/60 font-serif focus:outline-none"
                     [disabled]="isSubmitting">
            </div>
          </div>

          <button type="submit" [disabled]="phoneForm.invalid || isSubmitting"
                  class="w-full px-6 py-3 bg-[#A46A3F] text-white font-serif tracking-wide rounded-sm shadow-md hover:bg-[#8C5632] hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 uppercase text-sm flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed">
            <span *ngIf="!isSubmitting">Send OTP</span>
            <span *ngIf="isSubmitting" class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
          </button>
        </form>
      </div>

      <!-- OTP Verification Form (Sign Up) -->
      <div *ngIf="authMethod === 'phone' && showOtpInput" class="space-y-4 animate-fade-in">
        <div class="text-center space-y-2">
          <p class="text-sm text-[#8B7355]">Enter the 6-digit code sent to your phone</p>
          <button (click)="showOtpInput = false" class="text-xs text-[#A46A3F] hover:underline">Change Number</button>
        </div>
        <form [formGroup]="otpForm" (ngSubmit)="submitOtp()" class="space-y-4">
          <div class="space-y-1">
            <label class="block text-xs font-serif text-[#3A4D3F] tracking-wide">OTP Code</label>
            <input type="text" formControlName="otp" placeholder="123456" maxlength="6"
                   class="w-full px-4 py-3 bg-white border border-[#E5DDD5] text-[#3A2A25] placeholder-[#7A6E69]/60 font-serif text-center text-xl tracking-[0.5em] focus:outline-none focus:border-[#A46A3F] transition-colors rounded-sm"
                   [disabled]="isSubmitting">
          </div>

          <button type="submit" [disabled]="otpForm.invalid || isSubmitting"
                  class="w-full px-6 py-3 bg-[#A46A3F] text-white font-serif tracking-wide rounded-sm shadow-md hover:bg-[#8C5632] hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 uppercase text-sm flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed">
            <span *ngIf="!isSubmitting">Verify & Join</span>
            <span *ngIf="isSubmitting" class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
          </button>
        </form>
      </div>

      <div class="text-center text-sm text-[#8B7355]">
        <span>Already have an account? </span>
        <button type="button" (click)="switchToSignIn()" class="text-[#3A2A25] underline underline-offset-2 hover:text-[#A46A3F]">Sign in</button>
      </div>
    </div>

    <!-- Forgot Password Form -->
    <div *ngIf="authModalService.modalType() === 'forgot-password'" class="p-8 space-y-6">
      <div class="space-y-1 text-center">
        <h2 class="text-2xl font-serif text-[#3A2A25]">Forgot Password?</h2>
        <p class="text-sm text-[#8B7355]">Enter your email and we'll send you a reset link</p>
      </div>

      <form [formGroup]="forgotPasswordForm" (ngSubmit)="submitForgotPassword()" class="space-y-4">
        <div class="space-y-1">
          <label class="block text-xs font-serif text-[#3A4D3F] tracking-wide">Email</label>
          <input type="email" formControlName="email" placeholder="Enter your email"
                 class="w-full px-4 py-3 bg-white border border-[#E5DDD5] text-[#3A2A25] placeholder-[#7A6E69]/60 font-serif focus:outline-none focus:border-[#A46A3F] transition-colors rounded-sm"
                 [disabled]="isSubmitting">
        </div>

        <button type="submit" [disabled]="forgotPasswordForm.invalid || isSubmitting"
                class="w-full px-6 py-3 bg-gradient-to-r from-[#B8860B] to-[#C9A227] text-white font-serif tracking-wide rounded-sm shadow-md hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 uppercase text-sm flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed">
          <span *ngIf="!isSubmitting">Send Reset Link</span>
          <span *ngIf="isSubmitting" class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
        </button>
      </form>

      <div class="text-center text-sm text-[#8B7355]">
        <span>Remember your password? </span>
        <button type="button" (click)="switchToSignIn()" class="text-[#3A2A25] underline underline-offset-2 hover:text-[#A46A3F]">Sign in</button>
      </div>
    </div>

    <!-- Recaptcha Container (Hidden) -->
    <div id="recaptcha-container" class="hidden"></div>
  </div>
</div>
